import React, { useEffect, useState } from 'react';
import "./agent.css";
import SimpleTaxCalculator from './SimpleTaxCalculator';
import TaxWithHeldCalculator from './TaxWithHeldCalculator';
import IncomeTaxCalculator from './IncomeTaxCalculator';
import HomeOfficeExpensesCalculator from './HomeOfficeExpensesCalculator';
import LodgeTaxReturnCalculator from './LodgeTaxReturnCalculator';
import MedicalLevyCalculator from './MedicalLevyCalculator';
import SuperGuaranteeContributionsCalculator from './SuperGuaranteeContributionsCalculator';
import ResidentTaxCalculator from './ResidentCalculator';
import LodgeTaxCalculator from './LodgeTaxCalculator';
import DeterminationResidencyCalculator from './DeterminationResidencyCalculator';
import Decision7ACalculator from './Decison7aCalculator';

const ChatContent = ({selectedCalculator, setSelectedCalculator, newChatCreated}) => {
  const calculatorOptions = [
    { value: 'simple-tax-calculator', label: 'Simple Tax Calculator' },
    { value: 'tax-withheld-calculator', label: 'Tax Withheld Calculator' },
    { value: 'income-tax-calculator', label: 'Income Tax Calculator' },
    { value: 'home-office-expenses-calculator', label: 'Home Office Expenses Calculator' },
    { value: 'lodge-tax-return-calculator', label: 'Lodge Tax Return Calculator' },
    { value: 'medical-levy-calculator', label: 'Medical Levy Calculator' },
    { value: 'super-guarentee-calculator', label: 'Super Guarantee Contributions Calculator' },
    { value: 'resident-tax-calculator', label: 'Resident Tax Calculator' },
    { value: 'determination-residency-calculator', label: 'Determination Residency Calculator' },
    { value: 'decision-7a-calculator', label: 'Division 7A Calculator' }
  ];

  useEffect(() => {
    const createNewChat = async () => {
      await newChatCreated();
    };
    
    createNewChat();
  }, [selectedCalculator]);

  const renderCalculator = () => {
    switch (selectedCalculator) {
      case 'simple-tax-calculator':
        return <SimpleTaxCalculator />;
      case 'tax-withheld-calculator':
        return <TaxWithHeldCalculator />;
      case 'income-tax-calculator':
        return <IncomeTaxCalculator />;
      case 'home-office-expenses-calculator':
        return <HomeOfficeExpensesCalculator />;
      case 'lodge-tax-return-calculator':
        return <LodgeTaxCalculator/>;
      case 'medical-levy-calculator':
        return <MedicalLevyCalculator/>;
      case 'super-guarentee-calculator':
        return <SuperGuaranteeContributionsCalculator/>;
      case 'resident-tax-calculator':
        return <ResidentTaxCalculator/>;
      case 'determination-residency-calculator':
        return <DeterminationResidencyCalculator/>;
      case 'decision-7a-calculator':
        return <Decision7ACalculator/>;
      default:
        return <div>Please select a calculator</div>;
    }
  };

  return (
    <div className="chat-content-container">
      <div className="dropdown-container">
        <select 
          value={selectedCalculator || ''} 
          onChange={(e) => setSelectedCalculator(e.target.value)}
          className="calculator-dropdown"
        >
          <option value="">Select a calculator</option>
          {calculatorOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className="calculator-display">
        {renderCalculator()}
      </div>
    </div>
  );
};

export default ChatContent;
